/*
  CarouselEvo — Modern, Vanilla JavaScript Carousel
  -------------------------------------------------
  Usage (quick):
    const el = document.querySelector('.testimonials-carousel-container');
    const c = new CarouselEvo(el, {
      directionNav: true,
      buttonNav: 'none',    // 'none' | 'bullets' | 'numbers'
      autoplay: true,
      scaleDepth: false,    // keep cards constant size (recommended for text)
      hideEdgeSlides: false,// keep side cards visible
      backOpacity: 0.9,
      gap: 0.76,             // spacing factor between slides (0.5..1.2)
      frontWidth: 640,      // optional: if 0 derived from container
      frontHeight: 360
    });

  Public API:
    c.prev(), c.next(), c.goTo(i), c.pause(), c.resume(), c.destroy(), c.current, c.length
*/

(function (global) {
    'use strict';

    if (!jQuery('.acf-blocks-testimonials-rotating-carousel').length) {
        return;
    }

    class CarouselEvo {
        constructor(root, opts = {}) {
            if (!root) throw new Error('CarouselEvo: root element is required');
            this.root = root;
            this.slidesContainer = root.querySelector('.slides');
            if (!this.slidesContainer) throw new Error('CarouselEvo: .slides container not found');

            this.slideNodes = Array.from(this.slidesContainer.children).map(n => {
                n.classList.add('cevo-slideItem');
                n.style.position = 'absolute';
                n.style.left = '50%'; // we position everything around center
                n.style.top = '0';
                n.style.transformOrigin = '50% 50%';
                n.style.willChange = 'transform,opacity';
                return n;
            });

            this.opts = Object.assign({}, CarouselEvo.defaults, opts);
            if (this.opts.buttonNav === true) this.opts.buttonNav = 'bullets';

            this._n = this.slideNodes.length;
            this._current = 0;
            this._isAnimating = false;
            this._interval = null;

            // binds
            this._onResize = this._onResize.bind(this);
            this._onMouseEnter = this._onMouseEnter.bind(this);
            this._onMouseLeave = this._onMouseLeave.bind(this);

            this._prepare();
            this._bind();
            this._layout(true);
            if (this.opts.autoplay) this._runAutoplay();
        }

        // Public API
        prev() { this._goTo(this._current - 1, true, false); }
        next() { this._goTo(this._current + 1, true, false); }
        goTo(index) { this._goTo(index, true, false); }
        pause() { this._stopAutoplay(); this._userPaused = true; }
        resume() { this._userPaused = false; if (this.opts.autoplay) this._runAutoplay(); }
        get current() { return this._current; }
        get length() { return this._n; }

        destroy() {
            this._stopAutoplay();
            window.removeEventListener('resize', this._onResize);
            this.root.removeEventListener('mouseenter', this._onMouseEnter);
            this.root.removeEventListener('mouseleave', this._onMouseLeave);

            if (this._wheelHandler) this.root.removeEventListener('wheel', this._wheelHandler);
            if (this._touchHandlers) {
                this.root.removeEventListener('touchstart', this._touchHandlers.start);
                this.root.removeEventListener('touchmove', this._touchHandlers.move);
                this.root.removeEventListener('touchend', this._touchHandlers.end);
            }

            // remove UI
            const next = this.root.querySelector('.cevo-next'); if (next) next.remove();
            const prev = this.root.querySelector('.cevo-prev'); if (prev) prev.remove();
            const btnNav = this.root.querySelector('.cevo-buttonNav'); if (btnNav) btnNav.remove();
            const overlay = this.root.querySelector('.cevo-videoOverlay'); if (overlay) overlay.remove();
            const spinner = this.root.querySelector('.cevo-spinner'); if (spinner) spinner.remove();

            // clean slide styles
            this.slideNodes.forEach(n => {
                n.classList.remove('cevo-slideItem');
                n.style.cssText = '';
            });
        }

        // Internal setup
        _prepare() {
            this._injectBaseStyles();

            const rect = this.root.getBoundingClientRect();
            this.carouselWidth = this.opts.carouselWidth || Math.max(200, Math.round(rect.width));
            this.carouselHeight = this.opts.carouselHeight || Math.max(120, Math.round(rect.height));

            this.frontWidth = this.opts.frontWidth || Math.round(this.carouselWidth * 0.6);
            this.frontHeight = this.opts.frontHeight || Math.round(this.frontWidth * (9/16));

            this._attachTouch();

            if (this.opts.directionNav) this._createDirectionNav();
            if (this.opts.buttonNav && this.opts.buttonNav !== 'none') this._createButtonNav();

            this._createVideoOverlay();
        }

        _injectBaseStyles() {
            if (document.getElementById('cevo-base-styles')) return;
            const css = `
.cevo{position:relative;}
.cevo .slides{position:relative;width:100%;height:100%}
.cevo-slideItem{position:absolute;left:50%;top:0;transform-origin:50% 50%;}
.cevo .cevo-next,.cevo .cevo-prev{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;border:none;border-radius:999px;background:rgba(255,255,255,.9);display:grid;place-items:center;cursor:pointer;z-index:110}
.cevo .cevo-next{right:5px}.cevo .cevo-prev{left:5px}.cevo .cevo-prev svg,.cevo .cevo-next svg{display:block;width:11px;height:auto}
.cevo .cevo-buttonNav{position:absolute;left:50%;transform:translateX(-50%);bottom:10px;display:flex;gap:8px;z-index:35}
.cevo .cevo-bullet,.cevo .cevo-number{cursor:pointer;padding:6px;min-width:10px;display:grid;place-items:center;border-radius:999px;background:rgba(255,255,255,.7);border:1px solid rgba(0,0,0,.15)}
.cevo .cevo-bullet.active,.cevo .cevo-number.active{background:#111;color:#fff;border-color:#111}
.cevo .cevo-videoOverlay{position:absolute;z-index:40;display:none}
.cevo .cevo-spinner{position:absolute;z-index:50;display:none}
.cevo .cevo-reflection{position:absolute;left:0;overflow:hidden}
.cevo .cevo-shadow{position:absolute;left:0;bottom:0;right:0;pointer-events:none}
@media(max-width:460px){.cevo .cevo-next{right:-15px}.cevo .cevo-prev{left:-15px}}
      `;
            const style = document.createElement('style');
            style.id = 'cevo-base-styles';
            style.textContent = css;
            document.head.appendChild(style);
            // add container class for root so user CSS can target it easily
            this.root.classList.add('cevo');
        }

        _bind() {
            window.addEventListener('resize', this._onResize);
            this.root.addEventListener('mouseenter', this._onMouseEnter);
            this.root.addEventListener('mouseleave', this._onMouseLeave);

            if (this.opts.mouse) {
                this._wheelHandler = (e) => {
                    const delta = e.deltaY || e.wheelDelta || -e.detail;
                    if (delta > 0) this.next(); else if (delta < 0) this.prev();
                    e.preventDefault();
                };
                this.root.addEventListener('wheel', this._wheelHandler, { passive: false });
            }

            if (!this.root.hasAttribute('tabindex')) this.root.setAttribute('tabindex', '0');
            this.root.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowLeft') this.prev();
                else if (e.key === 'ArrowRight') this.next();
            });

            this.slideNodes.forEach((node, i) => {
                node.addEventListener('click', (ev) => {
                    if (i !== this._current) {
                        ev.preventDefault();
                        this._goTo(i, true, false);
                    }
                });
            });
        }

        _attachTouch() {
            let startX = 0, startY = 0, started = false;
            const start = (e) => { const t = e.touches ? e.touches[0] : e; startX = t.clientX; startY = t.clientY; started = true; };
            const move = (e) => { if (!started) return; const t = e.touches ? e.touches[0] : e; const dx = Math.abs(t.clientX - startX); const dy = Math.abs(t.clientY - startY); if (dx > 10 && dx > dy) e.preventDefault(); };
            const end = (e) => { if (!started) return; const t = e.changedTouches ? e.changedTouches[0] : e; const dx = t.clientX - startX; const dy = t.clientY - startY; started = false; if (Math.abs(dx) > Math.max(40, this.frontWidth * 0.08) && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) this.next(); else this.prev(); } };
            this._touchHandlers = { start, move, end };
            this.root.addEventListener('touchstart', start, { passive: true });
            this.root.addEventListener('touchmove', move, { passive: false });
            this.root.addEventListener('touchend', end, { passive: true });
            let mouseDown = false;
            this.root.addEventListener('mousedown', (e) => { mouseDown = true; start(e); });
            window.addEventListener('mousemove', (e) => { if (mouseDown) move(e); });
            window.addEventListener('mouseup', (e) => { if (mouseDown) { mouseDown = false; end(e); } });
        }

        // Layout
        _onResize() {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => {
                const rect = this.root.getBoundingClientRect();
                this.carouselWidth = this.opts.carouselWidth || Math.round(rect.width || this.carouselWidth);
                this.carouselHeight = this.opts.carouselHeight || Math.round(rect.height || this.carouselHeight);
                if (!this.opts.frontWidth) this.frontWidth = Math.round(this.carouselWidth * 0.6);
                if (!this.opts.frontHeight) this.frontHeight = Math.round(this.frontWidth * (9/16));
                this._layout(false);
            }, 80);
        }

        _layout(immediate = false) {
            const centerY = this.carouselHeight / 2;
            const opts = this.opts;

            for (let i = 0; i < this._n; i++) {
                const node = this.slideNodes[i];

                // relative index to current
                let rel = i - this._current;
                if (rel < 0) rel += this._n;
                let p = rel;
                if (p > Math.floor(this._n / 2)) p = p - this._n;
                const dist = Math.abs(p);

                let baseW = this.frontWidth;
                let baseH = this.frontHeight;

                // CIRCULAR MODE (new)
                if (opts.circularMode) {
                    const spacing = opts.circularGap ?? opts.gap; // fallback if circularGap not set
                    const visible = opts.circularVisible ?? 2;   // default 2 slides on each side

                    let opacity = 0, scale = 0.6, translateX = 0, zIndex = 0;

                    if (p === 0) {
                        scale = 1;
                        opacity = 1;
                        translateX = 0;
                        zIndex = 100;
                        node.classList.add('cevo-active');
                    } else if (Math.abs(p) <= visible) {
                        // interpolate scale and opacity based on distance
                        scale = 1 - 0.15 * Math.abs(p);
                        opacity = opts.backOpacity;
                        translateX = p * baseW * spacing;
                        zIndex = 100 - Math.abs(p) * 10;
                        node.classList.remove('cevo-active');
                    } else {
                        scale = 0.6;
                        opacity = 0;
                        translateX = 0;
                        zIndex = 0;
                        node.classList.remove('cevo-active');
                    }

                    if (immediate) node.style.transition = 'none';
                    else node.style.transition = `transform ${opts.speed}ms ease, opacity ${opts.speed}ms ease`;

                    node.style.width = `${baseW}px`;
                    node.style.height = `${baseH}px`;
                    node.style.left = '50%';
                    node.style.top = `${Math.round(centerY - (baseH * scale) / 2)}px`;
                    node.style.zIndex = `${zIndex}`;
                    node.style.opacity = `${opacity}`;
                    node.style.pointerEvents = (opacity === 0) ? 'none' : 'auto';
                    node.style.transform = `translateX(${translateX}px) translateX(-50%) scale(${scale})`;

                    if (immediate) {
                        void node.offsetWidth;
                        node.style.transition = `transform ${opts.speed}ms ease, opacity ${opts.speed}ms ease`;
                    }
                } else {
                    // DEFAULT MODE (your original layout)
                    const scale = opts.scaleDepth ? Math.pow(opts.backZoom, dist) : 1;
                    const renderedW = baseW * scale;
                    const renderedH = baseH * scale;

                    const translateX = Math.round(p * baseW * opts.gap);
                    const top = Math.round(centerY - (renderedH / 2));
                    const zIndex = (this._n + 100) - dist;

                    let opacity = 1;
                    if (dist === 0) opacity = 1;
                    else if (!opts.hideEdgeSlides) opacity = opts.backOpacity;
                    else {
                        const threshold = Math.max(1, Math.floor(opts.slidesPerScroll / 2));
                        opacity = (dist > threshold) ? 0 : opts.backOpacity;
                    }

                    if (immediate) node.style.transition = 'none';
                    else node.style.transition = `transform ${opts.speed}ms ease, opacity ${opts.speed}ms ease`;

                    node.style.width = `${baseW}px`;
                    node.style.height = `${baseH}px`;
                    node.style.left = '50%';
                    node.style.top = `${top}px`;
                    node.style.zIndex = `${zIndex}`;
                    node.style.opacity = `${opacity}`;
                    node.style.pointerEvents = (opacity === 0) ? 'none' : 'auto';
                    node.style.transform = `translateX(${translateX}px) translateX(-50%) scale(${scale})`;

                    if (opts.reflection) this._ensureReflection(node, baseW, baseH, renderedH);
                    if (opts.shadow) this._ensureShadow(node, baseW, renderedH);

                    if (immediate) {
                        void node.offsetWidth;
                        node.style.transition = `transform ${opts.speed}ms ease, opacity ${opts.speed}ms ease`;
                    }
                }
            }

            this._updateVideoOverlay();
            this._updateButtonNav();
        }

        _ensureReflection(node, baseW, baseH, renderedH) {
            let ref = node.querySelector('.cevo-reflection');
            if (!ref) { ref = document.createElement('div'); ref.className = 'cevo-reflection'; const rimg = document.createElement('div'); rimg.className = 'cevo-reflection-inner'; ref.appendChild(rimg); node.appendChild(ref); }
            ref.style.top = `${renderedH}px`;
            ref.style.height = `${Math.round(renderedH * this.opts.reflectionHeight)}px`;
            ref.style.opacity = `${this.opts.reflectionOpacity}`;
        }

        _ensureShadow(node, baseW, renderedH) {
            let sh = node.querySelector('.cevo-shadow');
            if (!sh) { sh = document.createElement('div'); sh.className = 'cevo-shadow'; node.appendChild(sh); }
            sh.style.height = `${Math.round(renderedH * 0.08)}px`;
        }

        // State change
        _goTo(index, stopAutoplay = true, pauseFlag = true) {
            if (this._isAnimating) return;
            if (typeof index !== 'number' || isNaN(index)) return;
            if (stopAutoplay) this._stopAutoplay();

            index = ((index % this._n) + this._n) % this._n;
            if (index === this._current) return;

            this._isAnimating = true;
            this._current = index;
            this._layout(false);

            setTimeout(() => {
                this._isAnimating = false;
                if (this.opts.autoplay && !this._userPaused) this._runAutoplay();
            }, this.opts.speed + 30);
        }

        // UI creation
        _createDirectionNav() {
            const next = document.createElement('button'); next.className = 'cevo-next'; next.type = 'button'; next.setAttribute('aria-label', 'Next');
            const prev = document.createElement('button'); prev.className = 'cevo-prev'; prev.type = 'button'; prev.setAttribute('aria-label', 'Previous');
            next.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="23" viewBox="0 0 14 23" fill="none">
                  <path d="M2.64742 22.7771L14 11.7771L2.64742 0.7771L0 3.3445L8.70289 11.7771L0 20.2097L2.64742 22.7771Z" fill="black"/>
                </svg>
            `;
            prev.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="23" viewBox="0 0 14 23" fill="none">
                  <path d="M11.3526 22.7771L0 11.7771L11.3526 0.7771L14 3.3445L5.29711 11.7771L14 20.2097L11.3526 22.7771Z" fill="black"/>
                </svg>
            `;
            this.root.appendChild(next); this.root.appendChild(prev);
            next.addEventListener('click', () => this.next());
            prev.addEventListener('click', () => this.prev());
        }

        _createButtonNav() {
            const wrapper = document.createElement('div'); wrapper.className = 'cevo-buttonNav';
            const useNumbers = (this.opts.buttonNav === 'numbers');
            for (let i = 0; i < this._n; i++) {
                const b = document.createElement('button'); b.type = 'button'; b.className = useNumbers ? 'cevo-number' : 'cevo-bullet';
                if (useNumbers) b.textContent = String(i + 1);
                b.addEventListener('click', () => this._goTo(i, true, false));
                wrapper.appendChild(b);
            }
            this.root.appendChild(wrapper);
            this._updateButtonNav();
        }

        _updateButtonNav() {
            const nav = this.root.querySelector('.cevo-buttonNav'); if (!nav) return;
            Array.from(nav.children).forEach((b, i) => b.classList.toggle('active', i === this._current));
        }

        // Autoplay
        _runAutoplay() {
            if (this._interval) clearInterval(this._interval);
            this._interval = setInterval(() => { this._goTo(this._current + 1, false, true); }, this.opts.autoplayInterval);
        }
        _stopAutoplay() { if (this._interval) { clearInterval(this._interval); this._interval = null; } }
        _onMouseEnter() { if (this.opts.autoplay && this.opts.pauseOnHover) this._stopAutoplay(); }
        _onMouseLeave() { if (this.opts.autoplay && this.opts.pauseOnHover && !this._userPaused) this._runAutoplay(); }

        // Video overlay (basic)
        _createVideoOverlay() {
            const spinner = document.createElement('div'); spinner.className = 'cevo-spinner'; spinner.style.display = 'none';
            const overlay = document.createElement('div'); overlay.className = 'cevo-videoOverlay'; overlay.style.display = 'none';
            overlay.addEventListener('click', () => this._insertVideo());
            this.root.appendChild(spinner); this.root.appendChild(overlay);
        }

        _isVideoSlide(i) {
            const a = this.slideNodes[i].querySelector('a.video');
            return !!(a && a.getAttribute('href'));
        }

        _getVideoSrc(url) {
            if (!url) return null;
            const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{4,})/i);
            if (yt) return `https://www.youtube.com/embed/${encodeURIComponent(yt[1])}?autoplay=1&rel=0`;
            const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
            if (vm) return `https://player.vimeo.com/video/${encodeURIComponent(vm[1])}?autoplay=1`;
            return null;
        }

        _updateVideoOverlay() {
            const overlay = this.root.querySelector('.cevo-videoOverlay'); if (!overlay) return;
            const spinner = this.root.querySelector('.cevo-spinner'); if (!spinner) return;
            if (!this._isVideoSlide(this._current)) { overlay.style.display = 'none'; overlay.innerHTML = ''; spinner.style.display = 'none'; return; }
            const node = this.slideNodes[this._current];
            const contRect = this.slidesContainer.getBoundingClientRect();
            const rect = node.getBoundingClientRect();
            overlay.style.left = (rect.left - contRect.left) + 'px';
            overlay.style.top = (rect.top - contRect.top) + 'px';
            overlay.style.width = rect.width + 'px'; overlay.style.height = rect.height + 'px';
            overlay.style.display = 'block'; overlay.innerHTML = '';
            spinner.style.display = 'none';
        }

        _insertVideo() {
            const overlay = this.root.querySelector('.cevo-videoOverlay'); if (!overlay) return;
            const a = this.slideNodes[this._current].querySelector('a.video'); if (!a) return;
            const src = this._getVideoSrc(a.getAttribute('href'));
            if (!src) return;
            overlay.innerHTML = '';
            const iframe = document.createElement('iframe');
            iframe.width = overlay.clientWidth; iframe.height = overlay.clientHeight; iframe.src = src; iframe.frameBorder = '0';
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            overlay.appendChild(iframe);
            this._stopAutoplay(); this._userPaused = true;
        }
    }

    CarouselEvo.defaults = {
        hAlign: 'center',
        vAlign: 'center',
        circularMode: false,
        circularVisible: 3,
        circularGap: null,
        hMargin: 0.2,
        vMargin: 0.1,
        frontWidth: 0,
        frontHeight: 0,
        carouselWidth: 0,
        carouselHeight: 0,
        backZoom: 0.82,
        slidesPerScroll: 5,
        speed: 450,
        buttonNav: 'none',
        directionNav: false,
        autoplay: true,
        autoplayInterval: 5000,
        pauseOnHover: true,
        mouse: true,
        shadow: false,
        reflection: false,
        reflectionHeight: 0.18,
        reflectionOpacity: 0.45,
        description: false,
        descriptionContainer: '.description',
        backOpacity: 0.9,

        // options for text-cards
        scaleDepth: true,
        hideEdgeSlides: true,
        gap: 0.76,

        before: function () {},
        after: function () {}
    };

    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = CarouselEvo;
    else global.CarouselEvo = CarouselEvo;

})(typeof window !== 'undefined' ? window : this);